import { useEffect, useRef } from 'react';

import { Calc } from '../Calc';
import type { Meta } from '../meta';
import type { FeedRow } from '../rows';
import { useScreen } from '../store';
import { PhoneQueueBar } from './PhoneQueue';

export function PhoneCalc({
  row,
  meta,
}: {
  row: FeedRow;
  meta: Meta;
}): React.ReactElement {
  const box = useRef<HTMLDivElement>(null);
  useEffect(() => {
    box.current?.querySelectorAll('input').forEach((el) => {
      if (el instanceof HTMLInputElement) el.setAttribute('inputmode', 'decimal');
    });
  });
  return (
    <div className="ph-sheet ph-sheet--calc" role="dialog" aria-label="калькулятор">
      <div className="ph-sheet__bar">
        <b>калькулятор</b>
        <button type="button" onClick={() => useScreen.getState().setOpen(null)}>
          закрыть
        </button>
      </div>
      <div className="ph-sheet__body" ref={box}>
        <PhoneQueueBar />
        <Calc row={row} meta={meta} face="desk" quietHint />
      </div>
    </div>
  );
}
